import {
  CollateralSummaryAmount as ICollateralSummaryAmount,
  CollateralSummaryAsset as ICollateralSummaryAsset,
  CollateralSummaryDebtorGuarantor as ICollateralSummaryDebtorGuarantor,
  CollateralSummaryItem as ICollateralSummaryItem,
  CollateralSummaryLoan as ICollateralSummaryLoan,
  CollateralSummaryPosition as ICollateralSummaryPosition,
} from '@eih-netbroker/api-position';
import { WithRequired } from '../utils';

export type CollateralSummaryAsset = ICollateralSummaryAsset;

export type CollateralSummaryPosition = ICollateralSummaryPosition & {
  id: string;
};

export type CollateralSummaryLoan = ICollateralSummaryLoan & {
  id: string;
};
export type CollateralSummaryDebtorGuarantor = ICollateralSummaryDebtorGuarantor & {
  __groupById: string;
};

export type CollateralSummaryItem = Required<
  Omit<ICollateralSummaryItem, 'assets' | 'positions' | 'loans' | 'debtorAndGuarantors'>
> & {
  assets: Array<CollateralSummaryAsset>;
  positions: Array<CollateralSummaryPosition>;
  loans: Array<CollateralSummaryLoan>;
  debtorAndGuarantors: Array<CollateralSummaryDebtorGuarantor>;
};

export type CollateralSummaryChartData = Pick<
  CollateralSummaryItem,
  | 'liquidation'
  | 'liquidationDifference'
  | 'marginRequirement'
  | 'warning'
  | 'warningDifference'
  | 'totalCollateralValue'
  | 'collateralValue'
  | 'guarantorAsset'
  | 'assetNonMarginSum'
  | 'positionNonMarginSum'
  | 'difference'
>;

export const CollateralSummaryLegendsList = [
  'collateralValue',
  'guarantorAsset',
  'totalCollateralValue',
  'assetNonMarginSum',
  'positionNonMarginSum',
] as const satisfies Array<keyof CollateralSummaryChartData>;

export const CollateralWarningLegendsList = ['marginRequirement', 'warning', 'liquidation'] as const satisfies Array<
  keyof CollateralSummaryChartData
>;

export const CollateralLegendsUnionList = [...CollateralSummaryLegendsList, ...CollateralWarningLegendsList] as const;

export type CollateralSummaryAmount = WithRequired<
  ICollateralSummaryAmount,
  'collateralValue' | 'marginRequirement' | 'warning' | 'warningDifference' | 'liquidation' | 'liquidationDifference'
>;
